import {
  CommonSuccessResponse,
  ReportParamsType,
} from "constants/types/common";
import {
  CollectionReportDetail,
  ProfitReportResponse,
  PurchaseReportRow,
} from "constants/types/report";
import useSWR from "swr";
import { serialize } from "utils/validation/string";

export const useProfitReport = (params: ReportParamsType | null) => {
  const {
    data,
    error,
    isLoading,
  }: {
    data: CommonSuccessResponse<ProfitReportResponse> | undefined;
    error: any;
    isLoading: boolean;
  } = useSWR(
    params?.startDate && params?.endDate
      ? `/report/profit?${serialize(params)}`
      : null,
    { refreshInterval: 0, revalidateOnFocus: false },
  );

  return {
    profitReport: data?.data,
    error,
    isLoading,
  };
};

export const useCollectionReport = (params: ReportParamsType | null) => {
  const {
    data,
    error,
    isLoading,
  }: {
    data: CommonSuccessResponse<CollectionReportDetail[]> | undefined;
    error: any;
    isLoading: boolean;
  } = useSWR(
    params?.startDate && params?.endDate
      ? `/report/payment-detail?${serialize(params)}`
      : null,
    { refreshInterval: 0, revalidateOnFocus: false },
  );

  return {
    collectionReport: data?.data,
    error,
    isLoading,
  };
};

export const usePurchaseReport = (params: ReportParamsType | null) => {
  const {
    data,
    error,
    isLoading,
  }: {
    data: CommonSuccessResponse<PurchaseReportRow[]> | undefined;
    error: any;
    isLoading: boolean;
  } = useSWR(
    params?.startDate && params?.endDate
      ? `/report/purchase-detail?${serialize(params)}`
      : null,
    { refreshInterval: 0, revalidateOnFocus: false },
  );

  return {
    purchaseReport: data?.data,
    error,
    isLoading,
  };
};
